<script setup>
import { Head, router } from "@inertiajs/vue3";

import Datatables from "@/Shared/Tables/Datatables.vue";
import DatatableFooterWrapper from "@/Shared/Tables/DatatableFooterWrapper.vue";

import VAlert from "@/Shared/VAlert.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VButtonCreate from "@/Shared/HeaderButton/VButtonCreate";
import VButton from "@/Shared/Buttons/VButton";
import { computed, ref } from "vue";
import VModalDownload from "./_partials/VModalDownload.vue";

let props = defineProps({
    title: String,
    additional: Object,
});

const {
    arrTemplateOptions,
    columns,
    canCreate,
    urlCreate,
    urlIndex,
    urlDownload,
} = props.additional;

const list = computed(() => props.additional.list);
const filters = computed(() => props.additional.filters);

const isShowForm = ref(false);

const breadcrumbs = [
    {
        url: "#",
        label: "Response List",
    },
];

const changePageLength = (value) => {
    getList({ per_page: value });
};

const onFilter = (value) => {
    getList({
        per_page: filters.per_page ?? 20,
        order_by: value.order_by,
        order_type: value.order_type,
        search_fields: value.search_fields,
        search_values: value.search_values,
    });
};

const getList = (params) => {
    router.get(urlIndex, params, {
        preserveState: true,
        replace: true,
    });
};

const showModal = () => {
    isShowForm.value = true;
};

const cancelForm = () => {
    isShowForm.value = false;
};
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <VAlert />

        <div class="card">
            <div class="card-body">
                <div class="text-end mb-3">
                    <VButtonCreate v-if="canCreate" :href="urlCreate">
                        Add Survey Entries
                    </VButtonCreate>

                    <VButton btnStyle="btn-success" @onClick="showModal">
                        <i class="fa fa-download"></i> Download
                    </VButton>
                </div>

                <div class="dataTables_wrapper dt-bootstrap5">
                    <Datatables
                        :columns="columns"
                        :pagination="list"
                        :filters="filters"
                        @onFilter="onFilter"
                    />

                    <DatatableFooterWrapper
                        :pagination="list.meta"
                        :filters="filters"
                        @onChange="changePageLength"
                    />
                </div>
            </div>
        </div>
    </div>

    <VModalDownload
        v-if="isShowForm"
        :urlDownload="urlDownload"
        :templateOptions="arrTemplateOptions"
        @onCancel="cancelForm"
    />
</template>
